// extracted by mini-css-extract-plugin
export default {"footerContainer":"PreviewChatModal__footerContainer___UrQCG"};